<div class="min-w-[145px]" data-testid="weighted-coverage-cell">
  <span class="inline-flex items-center gap-1 whitespace-nowrap">
    <b>{{ score() | appNumber: '1.2-2' }} %</b>
    @if (hasGaps()) {
      <i
        class="pi pi-exclamation-triangle text-orange text-sm"
        [pTooltip]="'project.steps.rfi.invitationList.hasGaps' | transloco"
        data-testid="coverage-gap-warning"
      ></i>
    }
    <app-rfi-analysis-info-button
      testId="open-coverage-analysis"
      (clicked)="analysisRequested.emit()"
    />
  </span>
  <app-rfi-coverage-bar
    class="mt-[7px] block"
    [percent]="score()"
    [fillClass]="barClass()"
    sizeClass="h-[5px] rounded-lg"
  />
</div>
